import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker   } from 'antd';


import attached from '../../assets/images/icon/paperclip.png';
import music from '../../assets/images/icon/music.png';
import pdf_ from '../../assets/images/icon/pdf_.png';
import image from '../../assets/images/icon/image.png';

const { TextArea } = Input;
const { Panel } = Collapse;

const buttonWidth = 70;

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}

function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}

class Index extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			size: 'default',
			quant: 'default',
			like: 'default',
			comment: 'default',
			notification: 'default',
			value: '',
		}
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
	}
	
	handleSizeChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

	render()

	{
	
	const { size } = this.state;
	const content = (
					  <div>
						<p className="center upload-img"><Tooltip placement="right" title="Audio"><img src={music} class="" alt="image" /></Tooltip></p>
						<p className="center upload-img"><Tooltip placement="right" title="Pdf"><img src={pdf_} class="" alt="image" /></Tooltip></p>
						<p className="center upload-img"><Tooltip placement="right" title="Image"><img src={image} class="" alt="image" /></Tooltip></p>
						
					  </div>
					);
	const radioStyle = {
		  display: 'block',
		  height: '30px',
		  lineHeight: '30px',
		};				
					
		return (
			<div>
			
			<div id="main" class="bg-off">
         <div class="row">
		 <div class="col s12 m12 ex-padd">
            <div id="breadcrumbs-wrapper" class="bg-off">
               <div class="">
                  <div class="row no-margin">
				  <div class="col s12 m12 header-title mt-20 mh-40 iq-card">
                     <div class="col s12 m6 l6 pt-10">
                        <h5 class="breadcrumbs-title"><span>Enquiries & Admision</span></h5>
                     </div>
                     <div class="col s12 m6 l6 right-align-md pt-10">
                        <ol class="breadcrumbs mb-0">
                           <li class="breadcrumb-item"><a href="/">Home</a>
                           </li>
                           <li class="breadcrumb-item"><a href="/reports/index">Reports</a>
                           </li>
                           <li class="breadcrumb-item active">Enquiries & Admision
                           </li>
                        </ol>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
            </div>
            
			<div class="col s12 m12 ex-padd">
            <div class="container ">
			   <div class="col s12 m12 mb-20 card-content mh-500 iq-card">
                  <section class="invoice-list-wrapper section food">
					 
					
					<div class="children bg-blue bg-color-1 communication iq-card2">
                     <Collapse defaultActiveKey={['1']} onChange={callback}>
						<Panel header="ENQUIRIES - PROGRAM WISE"  key="1">
							<div class="diary">
						<Collapse
							bordered={false}
							className="site-collapse-custom-collapse"
						  >
							<Panel header="Kidzonia Virar, Virar" key="1" className="site-collapse-custom-panel">
								<div class="col m12 mt-20 mb-20 text-right">
										<Button className="snd-btn " ><b>Download</b></Button>
								</div>
								 <div class="responsive-table ">
									<div class="dataTables_wrapper no-footer">
										<table class="table white border-radius-4 table_border center">
										  <thead>
											<tr>
											  <th><span>Program</span></th>
											  <th>Total Children</th>
											  <th>Total Enquiries</th>
											  <th>Enquiries-Admitted</th>
											  <th>Enquiries-Other</th>
											</tr>
										  </thead>
										  <tbody>
											<tr>
											  <td>Kindergarden</td>
											  <td>1</td>
											  <td>1</td>
											  <td>0</td>
											  <td>0</td>
											</tr>
										  </tbody>
										  <tfoot>
											<tr>
											  <th>Total</th>
											  <th>1</th>
											  <th>1</th>
											  <th>0</th>
											  <th>0</th>
											</tr>
										  </tfoot>
										</table>
									</div>
									</div>
								 
							</Panel>
							<Panel header="Test School, Andheri" key="2" className="site-collapse-custom-panel">
									<div class="col m12 mt-20 mb-20 text-right">
										<Button className="snd-btn " ><b>Download</b></Button>
								</div>
								 <div class="responsive-table ">
									<div class="dataTables_wrapper no-footer">
										<table class="table white border-radius-4 table_border center">
										  <thead>
											<tr>
											  <th><span>Program</span></th>
											  <th>Total Children</th>
											  <th>Total Enquiries</th>
											  <th>Enquiries-Admitted</th>
											  <th>Enquiries-Other</th>
											</tr>
										  </thead>
										  <tbody>
											<tr>
											  <td>Kindergarden</td>
											  <td>1</td>
											  <td>1</td>
											  <td>0</td>
											  <td>0</td>
											</tr>
										  </tbody>
										  <tfoot>
											<tr>
											  <th>Total</th>
											  <th>1</th>
											  <th>1</th>
											  <th>0</th>
											  <th>0</th>
											</tr>
										  </tfoot>
										</table>
									</div>
									</div>
							</Panel>
						  </Collapse>
					</div>
						</Panel>
					  </Collapse>
					</div>	
					
					<div class="children bg-blue bg-color-2 communication iq-card2">
                     <Collapse defaultActiveKey={['1']} onChange={callback}>
						<Panel header="ENQUIRIES - CHANNEL WISE"  key="1">
							<div class="diary">
						<Collapse
							bordered={false}
							className="site-collapse-custom-collapse"
						  >
							<Panel header="Kidzonia Virar, Virar" key="1" className="site-collapse-custom-panel ">
								<div class="col m12 mt-20 mb-20 text-right">
										<Button className="snd-btn " ><b>Download</b></Button>
								</div>
								 <div class="responsive-table ">
									<div class="dataTables_wrapper no-footer">
										<table class="table white border-radius-4 table_border center">
										  <thead>
											<tr>
											  <th><span>Channel Program</span></th>
											  <th>Credence.como</th>
											  <th>Digital Ads</th>
											  <th>Facebook</th>
											  <th>Flayers</th>
											  <th>Parent referral</th>
											  <th>Poster Ads</th>
											  <th>Staff referral</th>
											  <th>Walk in	</th>
											  <th>Website</th>
											  <th>Others</th>
											</tr>
										  </thead>
										  <tbody>
											<tr>
											  <td>Kindergarden</td>
											  <td>1</td>
											  <td>1</td>
											  <td>0</td>
											  <td>0</td>
											  <td>0</td>
											  <td>0</td>
											  <td>0</td>
											  <td>0</td>
											  <td>0</td>
											  <td>0</td>
											  
											</tr>
											<tr>
											  <td>General</td>
											  <td>1</td>
											  <td>1</td>
											  <td>0</td>
											  <td>0</td>
											  <td>0</td>
											  <td>0</td>
											  <td>0</td>
											  <td>0</td>
											  <td>0</td>
											  <td>0</td>
											  
											</tr>
										  </tbody>
										  <tfoot>
											<tr>
											  <th>Total</th>
											  <th>2</th>
											  <th>2</th>
											  <th>0</th>
											  <th>0</th>
											  <th>0</th>
											  <th>0</th>
											  <th>0</th>
											  <th>0</th>
											  <th>0</th>
											  <th>0</th>
											 
											</tr>
										  </tfoot>
										</table>
									</div>
									</div> 
								 
							</Panel>
							<Panel header="Test School, Andheri" key="2" className="site-collapse-custom-panel">
									<div class="col m12 mt-20 mb-20 text-right">
										<Button className="snd-btn " ><b>Download</b></Button>
								</div>
								 <div class="responsive-table ">
									<div class="dataTables_wrapper no-footer">
										<table class="table white border-radius-4 table_border center">
										  <thead>
											<tr>
											  <th><span>Channel Program</span></th>
											  <th>Credence.como</th>
											  <th>Digital Ads</th>
											  <th>Facebook</th>
											  <th>Flayers</th>
											  <th>Parent referral</th>
											  <th>Poster Ads</th>
											  <th>Staff referral</th>
											  <th>Walk in	</th>
											  <th>Website</th>
											  <th>Others</th>
											</tr>
										  </thead>
										  <tbody>
											<tr>
											  <td>Kindergarden</td>
											  <td>1</td>
											  <td>1</td>
											  <td>0</td>
											  <td>0</td>
											  <td>0</td>
											  <td>0</td>
											  <td>0</td>
											  <td>0</td>
											  <td>0</td>
											  <td>0</td>
											  
											</tr>
											<tr>
											  <td>General</td>
											  <td>1</td>
											  <td>1</td>
											  <td>0</td>
											  <td>0</td>
											  <td>0</td>
											  <td>0</td>
											  <td>0</td>
											  <td>0</td>
											  <td>0</td>
											  <td>0</td>
											  
											</tr>
										  </tbody>
										  <tfoot>
											<tr>
											  <th>Total</th>
											  <th>2</th>
											  <th>2</th>
											  <th>0</th>
											  <th>0</th>
											  <th>0</th>
											  <th>0</th>
											  <th>0</th>
											  <th>0</th>
											  <th>0</th>
											  <th>0</th>
											 
											</tr>
										  </tfoot>
										</table>
									</div>
									</div> 
							</Panel>
						  </Collapse>
					</div>
						</Panel>
					  </Collapse>
					</div>	
					
					
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
            </div>
			
         </div>
      </div>
     
			</div>
		) 
	} 
}
export default Index;
